import { Button, Col, Form, Input, message, Modal, Radio, Row, Spin } from 'antd';
import { useEffect, useState } from 'react';
import { getProject, createProject, updateProject } from '../../../services/general';

const ProjectModal = ({
  modal,
  setModal,
  setter,
  externalForm,
  formName,
  createTitle,
  editTitle,
  handleModalResult,
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState({ submit: false, fetch: false });

  const fetchProject = async () => {
    setLoading((_loading) => ({ ..._loading, fetch: true }));
    try {
      const id = externalForm.getFieldValue(formName);
      if (id) {
        const [response] = await getProject({ id });

        form.setFieldsValue({
          'active': !response.deleted_at,
          'name': response.name,
        })
      }
    } catch (error) {
      console.error(error);
      message.error({
        content: 'Error al obtener los datos del proyecto',
        style: {
          marginTop: '30vh',
        },
      });
    } finally {
      setLoading((_loading) => ({ ..._loading, fetch: false }));
    }
  }

  useEffect(() => {
    if (modal && form) {
      form.resetFields();
      if (modal.type === 'edit') {
        fetchProject();
      }
    }
  }, [modal?.visible]);

  const closeModal = () => {
    form.resetFields();
    setModal((_modal) => ({ ..._modal, visible: false }));
  };

  const submit = async () => {
    const validate = await form.validateFields();
    if (validate) {
      try {
        setLoading((_loading) => ({ ..._loading, submit: true }));
        const values = form.getFieldsValue();
        let responsePromise;
        const params = {
          active: values.active,
          name: values.name,
        };
        const id = externalForm.getFieldValue(formName);
        if (id) {
          responsePromise = await updateProject({
            ...params,
            id,
          });
        } else {
          responsePromise = await createProject(params);
        }
        const response = Array.isArray(responsePromise) ? responsePromise[0] : responsePromise;
        if (response.status === "error") {
          throw response;
        } else {
          setter([response]);
          externalForm.setFieldsValue({
            [formName]: response.id
          });

          handleModalResult(formName, response.id)

          message.success({
            content: `Proyecto ${modal.type === 'edit' ? 'actualizado' : 'creado'} exitosamente`,
            style: {
              marginTop: '40vh',
            },
          });
        }
        form.resetFields();
        setModal((_modal) => ({ ..._modal, visible: false }));
      } catch (error) {
        console.error(error);
        message.error({
          content: 'Error al crear el proyecto',
          style: {
            marginTop: '30vh',
          },
        });
      } finally {
        setLoading((_loading) => ({ ..._loading, submit: false }));
      }
    }
  };

  return (
    <Modal
      className="creation-modal company"
      open={modal?.visible}
      onCancel={closeModal}
      footer={false}
    >
      <Spin spinning={loading.fetch} className='cmt-spin'>
        <Form form={form} layout="vertical">
          <Row justify='center' className='mt-50'>
            <Col lg={16} xs={24} className='mb-10'>
              <h1>
                {modal.type === 'create' ? createTitle : editTitle}
              </h1></Col>
            <Col lg={16} xs={24}>
              <Form.Item
                label='Proyecto activo'
                name="active"
                rules={[{ required: true, message: 'Este campo es requerido' }]}
                className='mb-10'
              >
                <Radio.Group className="cmt-radio">
                  <Radio value={true}>Si</Radio>
                  <Radio value={false}>No</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
            <Col lg={16} xs={24}>
              <Form.Item
                name="name"
                label='Ingrese el nombre del nuevo proyecto que aparecerá en el listado.'
                rules={[{ required: true, message: 'Este campo es requerido' }]}
              >
                <Input
                  className="cmt-input"
                  id="businessNameTest"
                  placeholder='Ingrese nombre compañía'
                />
              </Form.Item>
            </Col>
          </Row>
          <Row justify='center' className="mt-20 mb-50" gutter={15}>
            <Col lg={8} xs={24}>
              <Button
                disabled={loading.submit}
                className='cmt-button primary outline'
                type='primary'
                onClick={closeModal}
              >
                Cancelar
              </Button>
            </Col>
            <Col lg={8} xs={24}>
              <Button
                loading={loading.submit}
                disabled={loading.submit}
                className='cmt-button primary'
                type='primary'
                onClick={submit}
              >
                {modal.type === 'create' ? createTitle : editTitle}
              </Button>
            </Col>
          </Row>
        </Form>
      </Spin>
    </Modal >
  )
}

export default ProjectModal;

